/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockCountTranEditor extends Serenity.Extensions.GridEditorBase<IcStockCountTranRow> {
        protected getColumnsKey() { return "Inventory.IcStockCountTran"; }
        protected getDialogType() { return IcStockCountTranDialog; }
        protected getLocalTextPrefix() { return IcStockCountTranRow.localTextPrefix; }

        public qnNo: number;
        


        public myPassValue: string;
        public myPassValue2: number;
        constructor(container: JQuery) {
            super(container);
        
        }
      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text(" สร้างรายการ"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {
                        this.createEntityDialog(this.getItemType(), dlg => {


                            var dialog = dlg as IcStockCountTranDialog;
                            dialog.onSave = (opt, callback) => this.save(opt, callback);
                            var entity = this.getNewEntity() as IcStockCountTranRow;

                            entity.SysDocNo = this.myPassValue;
                            if (this.myPassValue2 == 1) {
                                entity.Id = -1;
                            }



                            dialog.loadEntityAndOpenDialog(entity, false);
                        });
                    },
                }
            );
            
            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }
        validateEntity(row, id) {
            // row.PurUnitPrice = (row.CostValue || 0) / ((row.QtyOnhand || 1)-(row.QtyCount || 1));
            // row.UnitCost = (row.CostValue || 0 ) / (((row.QtyOnhand || 1)-(row.QtyCount || 1)) * (row.PurUnitRatio));
           return true;
       }
       protected createSlickGrid() {
        var grid = super.createSlickGrid();

        // need to register this plugin for grouping or you'll have errors
        grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

        this.view.setSummaryOptions({
            aggregators: [
                new Slick.Aggregators.Sum('QtyCount'),
                
                new Slick.Aggregators.Sum('QtyOnhand')
            ]
        });
        return grid;
    }

    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected usePager() {
        return false;
    }

    }
}

